<template>
	<div>
<app-title>Personalise</app-title>
	</div>
</template>

<script>
export default {};
</script>

<style scoped>
</style>